export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40a2ef06972b829f5f1dc1af1fa63719921099e605&name=revalidateCommunity!'